import api from '../../../plugins/api';
import { checkError, cloneDeep, parseAddressToApp, prepareApiParams } from 'erp-skeleton-library/utils';
import {userType} from "../../../plugins/enums";

const template =  {
  id: 0,
  type: userType.TYPE_USER,
  student: true,
  name: null,
  tradeName: null,
  taxId: null,
  studentCustomer: null,
  studentCustomerId: null,
  phones: [ {} ],
  addresses: [
    {
      address: {
        zipCode: undefined,
        city: undefined,
        state: undefined,
        address: undefined,
        number: undefined,
      },
    },
  ],
};

const state = {
  tableLoading: false,
  allStudents: [],
  registerStudent: cloneDeep(template),
  headers: [
    {
      text: 'Nome',
      align: 'left',
      value: 'name',
    },
    {
      text: 'CPF',
      align: 'left',
      value: 'taxId',
    },
  ],
};

const mutations = {
  LIST(state, payload) {
    state.allStudents = payload;
    state.tableLoading = false;
  },
  SET(state, payload) {
    if (!!payload) {
      payload.addresses = parseAddressToApp(payload);
      payload.phones = (payload.phones) ? payload.phones : [ {} ];
      state.registerStudent = payload;
    } else {
      state.registerStudent = cloneDeep(template);
    }
  },
  CREATE_PHONE(state) {
    state.registerStudent.phones.push({});
  },
  DELETE_PHONE(state, index) {
    state.registerStudent.phones.splice(index, 1);
  },
};

const actions = {
  create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post('users', payload)
           .then(response => {
              resolve(response.data);;
           }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  list({ commit }, payload) {
    state.tableLoading = true;
    let query = prepareApiParams(payload, 'id, name, taxId');
    query.type = userType.TYPE_USER;
    query.student = true;

    return new Promise((resolve, reject) => {
      api
        .get('users?' + new URLSearchParams(query).toString())
        .then(response => {
          commit('LIST', response.data.entities);
          state.tableLoading = false;
          resolve(response.data);
        })
        .catch(error => {
          state.tableLoading = false;
          checkError(error.response.status);
          reject(error.response);
        });
    });
  },
  read({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.get('users/' + id)
           .then(response => {
             commit('SET', response.data);
             resolve(response.data);
           }).catch(error => {
             console.log(error)
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  readCertificate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get('classes/' + payload.class + '/students/' + payload.id + '/certification')
          .then(response => {
            resolve(response.data);
          }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.put('users/' + payload.id, payload).then(response => {
                resolve(response.data);
;
      }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.delete('users/' + id)
           .then((response) => {
              resolve(response.data);;
           })
           .catch((error) => {
             checkError(error.response.status);
             reject(error.response);
           });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
